import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgPlus(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.75 17.25V28H17.25V17.25H28V14.75H17.25V4H14.75V14.75H4V17.25H14.75Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
